import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { connect } from 'react-redux';
import { isNotLogin, isNotLoginOrExpired } from '../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../helpers/EventEmitter';
import Item from './Item';
import { I18n } from 'react-redux-i18n';

class Tab extends React.Component {
  componentDidMount() {
    const { listTab, currentTab } = this.props;
    const isCurrentTabLocked = this.isLock(currentTab - 1);
    if (isCurrentTabLocked) {
      const tabIndexs = Object.values(I18n.t(listTab)).map((_, index) => index);
      const notLockIndex = tabIndexs.find((_, index) => !this.isLock(index));
      this.changeTab(notLockIndex)();
    }
  }

  changeTab = pos => () => {
    const { changeTab } = this.props;
    if (this.isLock(pos)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    changeTab(pos + 1);
  };

  getClassName = () => {
    const { isLineLinkLeft } = this.props;

    return `nav nav-tabs m-tabs-line m-tabs-line--success custom-tabs
    ${isLineLinkLeft && 'nav-line-link-left'}`;
  };

  isLock = index => {
    const { user, locks, lockOnlyGuest } = this.props;
    if (lockOnlyGuest) {
      return isNotLogin(user) && locks.includes(index + 1);
    }

    return isNotLoginOrExpired(user) && locks.includes(index + 1);
  };

  render() {
    const { listTab, currentTab } = this.props;

    const tabs = Object.values(I18n.t(listTab)).map(value => {
      return { name: value };
    });

    return (
      <ul className={this.getClassName()}>
        {tabs.map((value, index) => {
          return (
            <Item
              key={index}
              {...value}
              isLock={this.isLock(index)}
              isActive={currentTab === index + 1}
              changeTab={this.changeTab(index)}
            />
          );
        })}
      </ul>
    );
  }
}

Tab.propTypes = {
  listTab: PropTypes.string.isRequired,
  currentTab: PropTypes.any,
  changeTab: PropTypes.func,
  isLineLinkLeft: PropTypes.bool,
  locks: PropTypes.array,
  lockOnlyGuest: PropTypes.bool,
};

Tab.defaultProps = {
  currentTab: 0,
  changeTab: () => {},
  isLineLinkLeft: false,
  locks: [],
  lockOnlyGuest: false,
};

const mapStateToProps = state => ({
  i18n: state.i18n,
  user: state.userInfo,
});

export default connect(mapStateToProps)(Tab);
